import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window (and the main scroll container) to the top whenever
 * the route's pathname changes. Hash links (e.g. /page#section) are
 * preserved — the browser's native anchor behavior still applies.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Reset any leaked body/html scroll locks from dialogs, sheets, or
    // drawers that unmounted mid-animation (a common cause of "frozen"
    // pages on mobile). This runs on every route change.
    try {
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("pointer-events");
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");
      document.documentElement.style.removeProperty("overflow");
      // Radix sets data-scroll-locked on <html> when a dialog opens
      document.documentElement.removeAttribute("data-scroll-locked");
    } catch {}

    if (hash) return; // let in-page anchors work normally
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;